module.exports = __WEBPACK_EXTERNAL_MODULE_34__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 34
// module chunks = 0